/**
 * Thin HTTP client wrapper for the backend JSON API.
 *
 * In local development the Vite dev server proxies /api/v1 to the Flask
 * backend so session cookies are same-origin. In production this assumes
 * the frontend and backend are served from the same origin or that the
 * backend sets appropriate CORS + cookie headers.
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'

export async function apiClient(path, options = {}) {
  const url = `${API_BASE_URL}${path}`
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    credentials: 'include',
    ...options,
  })

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}))
    const error = new Error(errorBody.error || `API error: ${response.status} ${response.statusText}`)
    error.code = errorBody.code || null
    error.status = response.status
    throw error
  }

  return response.json()
}

export default apiClient
